export default __webpack_public_path__ + "static/energy-bc218c6013ea68315d37dbcc0fdb4af2.png";